/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Geofences Draw Icon component.
 */
export const GeofencesDrawIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='GeofencesDrawIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 28 26' fill='none'>
        <path d='M10.9078 17.2987C10.4786 16.8541 10.0337 16.1394 9.61178 15.2292C9.19326 14.3262 8.81129 13.2612 8.49637 12.1422C7.91519 10.0772 7.57695 7.88134 7.63493 6.22744C9.23152 6.1675 11.3513 6.51803 13.3447 7.1202C14.4249 7.4465 15.453 7.84226 16.3246 8.27587C17.2032 8.71295 17.8931 9.1739 18.3223 9.61855C20.123 11.484 20.7841 15.0698 18.4771 17.4596C16.17 19.8493 12.7085 19.1642 10.9078 17.2987Z'
          stroke={iconColor} />
        <ellipse rx='1.47149' ry='1.47149' transform='matrix(-0.689306 0.714012 -0.699867 -0.72505 14.3621 13.1966)' fill={iconColor} />
        <path d='M14.7031 13.5488L7.91463 6.51654' stroke={iconColor} />
      </svg>
    )} />
  );
};
